var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-outline-secondary",class:_vm.classObject,on:{"click":_vm.setBrand}},[_c('input',{attrs:{"type":"radio","name":"options","id":"option1","autocomplete":"off"}}),_vm._v(" "),_c('img',{staticClass:"brand-logo",attrs:{"src":_vm.brand.get('data').logo}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8764668","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/params/BrandButton.vue
// module id = d+7r
// module chunks = 0